import * as React from "react";
import { SVGProps } from "react";

const Kingmoney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_2_1_"
    x={0}
    y={0}
    viewBox="0 0 64 64"
    {...props}
  >
    <style>{".st1{fill:#fff}"}</style>
    <g id="layer1" transform="translate(0 -117)">
      <g id="g879" transform="matrix(.99659 0 0 .99658 -15.816 41.093)">
        <circle
          id="path964"
          cx={48.2}
          cy={108.5}
          r={32}
          fill="#ff7e00"
          stroke="#e74040"
          strokeLinecap="square"
          strokeLinejoin="round"
          strokeMiterlimit={3.986}
          strokeOpacity={0}
          strokeWidth={0.621}
        />
        <g id="g972-3" transform="translate(-214.572 -53.24) scale(1.20104)">
          <g id="g962-6" transform="translate(127 29.633)">
            <path
              id="path903-7"
              d="m80.3 116.4-2.7-10.9 4.3 3 1.2-3.3-8.4-5.9s-4.8-3.4-2.4 3.3l5.7 15.7c.8 2.1.8 2.1 4.4 2.1l6.5-17.8c1.2-3.3 4.6-3.4 5.8 0l6.5 17.8c3.6 0 3.6 0 5.1-4.1 1.7-4.7 3-8.2 5-13.7 2.4-6.7-2.4-3.3-2.4-3.3l-8.4 5.9 1.2 3.4 4.3-3-2.8 10.7-8.6-23.5c-1.6-4.6-4.2-4.6-5.9-.1l-8.4 23.7z"
              className="st1"
            />
            <path
              id="path909-5"
              d="m84.6 120.5 2-5.5 8.2-5.7.8 2.1c.2.7-.2 1.5-.9 2l-2.9 2.1 1.2 5h-2.5l-.9-3.5-1.4 1-.9 2.5h-2.7z"
              className="st1"
            />
            <path
              id="path911-3"
              d="M98.9 120.5h-2.7l-1.2-4.7 1.7-1.2 2.2 5.9z"
              className="st1"
            />
            <path
              id="path913-5"
              d="m88 111.4 1.9-5.3c.4-1.2.6-1.2.6 0v3.5l-2.5 1.8z"
              className="st1"
            />
            <path
              id="path915-6"
              d="m93 107.9 1-.8-.4-1.1c-.4-1.2-.6-1.2-.6 0v1.9z"
              className="st1"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Kingmoney;
